import { OfferLetterStatus } from "../../../graphql/generated.ts";
import { toHumanReadable } from "../../../utils/string.ts";

export const offerLetterStatusOptions = Object.values(OfferLetterStatus).map(
  (value) => {
    return { value, label: toHumanReadable(value) };
  }
);
